import microuniversoApi from "app/api/microuniversoApi"
import { atualizarItensAction, sobrescreverInformacoesAction } from "app/redux/orcamentoSlice"
import store from "app/redux/store/store"
import { DataFormatoEN } from "app/types/DataFormatoEN"
import { IOrcamento } from "app/types/IOrcamento"


import globalMU from "globalMU"

declare var window: any

export type AlterarDataPrevisaoEntregaItemInput = {
    identificadorItem: number,
    dataPrevisaoEntrega: DataFormatoEN,
    itemLegado?: any
}

export async function alterarDataPrevisaoEntregaItem(input: AlterarDataPrevisaoEntregaItemInput) {
    try {
        globalMU.blockUI({ tryPassiveLoading: true })

        const orcamentoAtualizado = await microuniversoApi.Orcamento.alterarDataPrevisaoEntregaItem(input.identificadorItem, input.dataPrevisaoEntrega,
            store.getState().orcamento.IdentificadorOrcamento)
            
            const atualizarRedux = (orcamentoAtualizado: IOrcamento) => {
                const valorParametro_ORCAMENTO_OUTRAS_SAIDAS_RETIRADA_OUTRO_LOCAL = store.getState().parametros?.["ORCAMENTO_OUTRAS_SAIDAS_RETIRADA_OUTRO_LOCAL"]
                store.dispatch(sobrescreverInformacoesAction(orcamentoAtualizado))
                store.dispatch(atualizarItensAction({itens: orcamentoAtualizado.ItensOrcamento, acao: "SOBRESCREVER",corPorAmbiente: store.getState().corPorAmbiente, valorParametro_ORCAMENTO_OUTRAS_SAIDAS_RETIRADA_OUTRO_LOCAL}))
            }
            
            if (!("HasErrors" in orcamentoAtualizado)) {
                atualizarRedux(orcamentoAtualizado)
            } else {
                const valorParametro_ORCAMENTO_OUTRAS_SAIDAS_RETIRADA_OUTRO_LOCAL = store.getState().parametros?.["ORCAMENTO_OUTRAS_SAIDAS_RETIRADA_OUTRO_LOCAL"]
                const index = store.getState().orcamento.ItensOrcamento.findIndex(i => i.Identificador == input.identificadorItem);
                const dataPrevisaoEntregaOld = store.getState().orcamento.ItensOrcamento[index].DataPrevisaoEntrega
                let itensClone = store.getState().orcamento.ItensOrcamento.map(item => ({ ...item }));
                itensClone[index].DataPrevisaoEntrega = '2000-01-01';
                store.dispatch(atualizarItensAction({itens: itensClone, acao: "SOBRESCREVER",corPorAmbiente: store.getState().corPorAmbiente, valorParametro_ORCAMENTO_OUTRAS_SAIDAS_RETIRADA_OUTRO_LOCAL}))    
                itensClone[index].DataPrevisaoEntrega = dataPrevisaoEntregaOld
                store.dispatch(atualizarItensAction({itens: itensClone, acao: "SOBRESCREVER",corPorAmbiente: store.getState().corPorAmbiente, valorParametro_ORCAMENTO_OUTRAS_SAIDAS_RETIRADA_OUTRO_LOCAL}))
            }
    
        // const atualizarOrcamentoLegado = () => {
        //     const itemAtualizado = orcamentoAtualizado.ItensOrcamento.find(i => i.Identificador == input.identificadorItem)
        //     const orcamentoLegado = window.orcamentoController.model
            
        //     if (input.itemLegado != null) {
        //         input.itemLegado.atualizar(itemAtualizado)
        //     }
            
        //     orcamentoLegado.atualizarItens(orcamentoAtualizado.ItensOrcamento)
        // }
    
        //atualizarRedux()
        //atualizarOrcamentoLegado()
    } finally {
        globalMU.unblockUI()
    }
}